import type { ProviderFieldSchema } from '@/domain/providerConfig';

import styles from './ProviderSchemaField.module.scss';

/** Kinds whose values are addresses or identifiers, read character by character. */
const MACHINE_KINDS: ReadonlySet<ProviderFieldSchema['kind']> = new Set([
    'url',
    'host',
    'clarifyItem',
    'integerList',
    'stringList',
    'identifier',
    'qualifiedName',
]);

/**
 * The class for a field's value box: monospace for machine values, by kind, or by the schema's
 * `display: 'machine'` for an identifier in a text field (a tenant).
 */
export function valueClassOf(
    field: Pick<ProviderFieldSchema, 'kind' | 'display'>
): string | undefined {
    return MACHINE_KINDS.has(field.kind) || field.display === 'machine'
        ? styles.machineValue
        : undefined;
}
